import { Banner } from '@/components/ui/banner'
import { SUPPORT_EMAIL } from '@/config/config'

/** Why a carrier sees no description of operations field. */
export function DescriptionOfOperationsNotice() {
  return (
    <Banner variant="warning">
      The description of operations on a certificate is worded by us. To add or change one, contact us at{' '}
      <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
    </Banner>
  )
}
